// Copyright 2015-2021 JC Fisher

"use strict";

module.exports = require("./lib/formula.min.js");
